/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('MemberBookingController', MemberBookingController);

    MemberBookingController.$inject = ['$state', 'MemberBooking', 'BoardBookingSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', '$stateParams', '$http'];

    function MemberBookingController($state, MemberBooking, BoardBookingSearch, ParseLinks, AlertService, paginationConstants, pagingParams, $stateParams, $http) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.loadAll = loadAll;
        vm.updateBooking = updateBooking;

        loadAll();

        function loadAll () {
            MemberBooking.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var sorting = vm.reverse ? 'asc' : 'desc';
                var result = [vm.predicate + ',' + sorting];
                if (vm.predicate !== 'id') {
                    result.push('id,' + sorting);
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.bookings = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                select: vm.select
            });
        }

        function updateBooking(bookingID, sksTheoryAvailable) {
            var booking = {};
            booking.id = bookingID;
            booking.sksTheoryAvailable = sksTheoryAvailable;
            MemberBooking.update(booking, function(result) {
                console.log(result);
                loadAll();
            }, function () {
                console.log("error");
            });
        }
    }
})();
